import Vue from "vue";
import Vuex from "vuex";
import VuexI18n from "vuex-i18n"; // load vuex i18n module
import app from "@/store/modules/app";
// product module
import product from "@/store/modules/product";
// auth module
import auth from "@/store/modules/auth";
import order from "@/store/modules/order";
import reason from "@/store/modules/reason";
import promoBanners from "@/store/modules/promo-banners";
import categoryTiles from "@/store/modules/category-tiles";
import locations from "@/store/modules/locations";
import categories from "@/store/modules/categories";
import delivery from "@/store/modules/delivery";
import deliveryTypes from "@/store/modules/deliveryTypes";
import deliverySlots from "@/store/modules/deliverySlots";
import deliveryCalendar from "@/store/modules/deliveryCalendar";
import deliverySlotExceptions from "@/store/modules/deliverySlotExceptions";
import deliveryPromotions from "@/store/modules/deliveryPromotions";

import * as getters from "./getters";

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  getters,
  modules: {
    app,
    product,
    auth,
    order,
    reason,
    categories,
    promoBanners,
    categoryTiles,
    locations,
    delivery,
    deliveryTypes,
    deliverySlots,
    deliveryCalendar,
    deliverySlotExceptions,
    deliveryPromotions,
  },
  state: {},
  mutations: {},
});

Vue.use(VuexI18n.plugin, store);

export default store;
